import { WalletAddressCell } from '@root/entities/wallet/ui/table/column/wallet-address-cell'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const WalletsTableAddressCell: React.FC<Props> = ({ wallet }) => {
  return <WalletAddressCell walletAddress={wallet.address} />
}
